import crypto from 'crypto';
import config from '@/config/index';

/**
  * md5加密
  * @param {String} str md5
  * @param {*} decode
  */
function md5(str, decode) {
  return crypto
    .createHash('md5')
    .update(str)
    .digest(decode);
}

/**
* 生成签名
* @param {*} data
*/
const secretKeyKey = 'secretKey';
function genSign(signSata = {}) {
  const signSecretKey = 'ydsecret://pc.doctran/sign/=*jn4[84Lns-$Lg]K4o0N2}';
  // const signSecretKey = store.state.key.secretInfo.documentTranslate;
  const data = { ...signSata };
  // const keySortArr = Object.keys(data)
  //   .sort()
  //   .filter((v) => !(data[v] === undefined));
  // keySortArr.push(secretKeyKey);
  data[secretKeyKey] = signSecretKey;
  // 必须按照src、salt、secretKey、content的顺序
  const sign = `${data.src}${data.salt}${data.secretKey}${data.content ? data.content : ''}`;
  return [md5(sign, 'hex')];
}

const { src } = config;
console.log(src);

function paramsAddSign(params) {
  const signData = {
    // src: 'deskdict.doctrans',
    src,
    salt: Date.now(),
  };
  if (params.docKey) {
    signData.content = params.docKey;
  }
  if (params.docKeyArray) {
    const content = JSON.parse(params.docKeyArray)[0];
    signData.content = content;
  }
  const [sign] = genSign(signData);
  Object.assign(signData, {
    sign,
  }, params);
  delete signData.content;
  return signData;
}

export default {
  md5,
  paramsAddSign,
};
